import searchByConstant from './searchByConstant';
import extractValues from './extractValues';
import convertDate from './convertDate';
import addID from './addId';
import createURLChunk from './createUrlChunk';
import calculateAge from './calculateAge';

const utils = {
  searchByConstant,
  extractValues,
  convertDate,
  addID,
  createURLChunk,
  calculateAge,
};

export default utils;
